/**
 * The Kendo single-page-application Router object.  This object is a singleton that is required by anything that
 * needs to route to a new view.
 */
import topic from "common/managers/topic";
import window from "common/objects/window";

var router = new(kendo.Router.extend({

    // whether application is in a dashboards designer route
    inDashboardsDesigner: false,

    init: function() {
        kendo.Router.fn.init.apply(this, arguments);
        this.bind("routeMissing", this._missing);
        this.bind("back", this._back);
    },

    setInDashboardsDesigner: function(value) {
        this.inDashboardsDesigner = value ? true : false;
    },

    /**
     * Remove traces of url api call from url.
     */
    endCall: function() {
        router.destroy();
        window.location.hash = "#";
    },

    _missing: function(e) {
        console.warn("Unknown route: " + e.url);
        window.location.href = context.path + "/application/locale/en_US/404.html";
    },

    _back: function(e) {
        if (this.inDashboardsDesigner) {
            // fire back event for dashboards designer, should port to onHide when refactored
            topic.publish("nav/dashboardsDesigner/back", e);
        }
    },

    getCurrentHash: function() {
        return window.location.hash;
    }

}))();

export default router;
